module.exports = __webpack_public_path__ + "4b45c9e1d430c0a2ff035a25714e4169.svg";